import { setDragGhost } from '../../dnd/pointerDrag';
import { useApp } from '../../context/AppContext';
import { useBilling } from '../../context/BillingContext';
import { useI18n } from '../../i18n/useI18n';
import { UiProvider } from '../../context/UiContext';
import { useUi } from '../../context/UiContext';
import { DayBoard } from '../board/DayBoard';
import { ListPanel } from '../board/ListPanel';
import { TaskDetail } from '../board/TaskDetail';
import { ProModal } from '../overlays/ProModal';
import { RecurModal } from '../overlays/RecurModal';
import { RecurringPanel } from '../overlays/RecurringPanel';
import { ShortcutsDialog } from '../overlays/ShortcutsDialog';
import { Sidebar } from './Sidebar';
import { StatusBar } from './StatusBar';
import { TopBar } from './TopBar';
import styles from './AppShell.module.css';

function Shell() {
  const { state, actions } = useApp();
  const billing = useBilling();
  const { t } = useI18n();
  const { ui } = useUi();

  const onResize = (event) => {
    if (event.button !== 0) return;
    event.preventDefault();
    const startY = event.clientY;
    const startH = state.listsHeight;
    const move = (moveEvent) => {
      const max = Math.round(window.innerHeight * 0.62);
      const next = Math.min(Math.max(startH - (moveEvent.clientY - startY), 180), max);
      actions.setListsHeight(next);
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <div className={styles.shell}>
      <Sidebar />
      <div className={styles.main}>
        <TopBar />
        <div className={styles.workspace}>
          <DayBoard />
          {state.listsExpanded && (
            <div
              className={styles.resizer}
              role="separator"
              aria-orientation="horizontal"
              aria-label={t('lists.resize')}
              onPointerDown={onResize}
            />
          )}
          <ListPanel />
          <TaskDetail detail={ui.detail} />
          <RecurringPanel open={ui.recurringOpen} />
        </div>
        <StatusBar />
      </div>
      {billing?.notice ? (
        <div className={styles.toast} role="status">
          <span>{t(`billing.${billing.notice}`)}</span>
          <button type="button" onClick={billing.clearNotice}>{t('billing.dismiss')}</button>
        </div>
      ) : null}
      {state.undo && (
        <div className={styles.toast} role="status">
          <span>{t(state.undo.message)}</span>
          <button type="button" onClick={actions.undo}>
            {t('undo.action')}
          </button>
        </div>
      )}
      {ui.proOpen && <ProModal />}
      {ui.helpOpen && <ShortcutsDialog />}
      {ui.recurCreate && <RecurModal />}
      <div className="drag-ghost" ref={setDragGhost} hidden />
    </div>
  );
}

export function AppShell() {
  return (
    <UiProvider>
      <Shell />
    </UiProvider>
  );
}
